import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { ProfileImageUpload } from '../models/profile-image-upload';
import { Organizer } from '../models/organizer';
import { ContentsMandatory } from '../models/contents-mandatory';

@Injectable()
export class OrganizersService {

	constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

	getSingleOrganizer(eventId: string, organizerId: string): Observable<Organizer> {
		let data: AngularFireObject<Organizer> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.ORGANIZERS_URL + "/" + organizerId);
		return data.valueChanges();
	}

	getOrganizersList(eventId: string) {
		if (this.utilityService.isLogged()) {
			return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.ORGANIZERS_URL);
		}
		return null;
	}

	addOrganizerDetails(organizer: Organizer, eventId: string) {
		return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.ORGANIZERS_URL).push(organizer).key;
	}

	updateOrganizerDetails(organizer: Organizer, eventId: string, organizerId: string): Promise<any> {
		console.log(organizer, eventId, organizerId)
		return this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.ORGANIZERS_URL + "/" + organizerId).set(organizer);
	}

	updateOrganizerPosition(eventID, organizersList) {
		// TODO: This should be 1 query. Right now ther are multiple.
		for (let item of organizersList) {
			let key = item.$key;
			this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.ORGANIZERS_URL + "/" + key).update({ position: item.position });
		}
	}

	getOrganizerType(eventId: string): Observable<Organizer> {
		let data: AngularFireObject<Organizer> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.CATEGORY_ORGANIZERS);
		return data.valueChanges();
	}

	deleteOrganizer(organizer: Organizer, eventId: string, organizersList) {
		if (organizersList.length <= 0) {
			return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.ORGANIZERS_URL).remove(organizer.$key);
		} else {
			this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.ORGANIZERS_URL).remove(organizer.$key);
			let i = 0;
			for (let item of organizersList) {
				let key = item.$key;
				var data = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.ORGANIZERS_URL + "/" + key).update({ position: item.position });
				i++;
				if (i == organizersList.length) {
					return data;
				}

			}
		}

	}
	
	addBulkOrganizers(organizer: any, eventID: string) {
		return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.ORGANIZERS_URL).set(organizer);
	}

	getAllOrganizers(eventId: string,) {
		return firebase.database().ref(Constants.EVENT_URL + '/' + eventId + Constants.ORGANIZERS_URL).once("value");
		}

	// deleteIconFile(iconName: string) {
	// 	return firebase.storage().ref();
	// }
	// deleteLogoFile(logoName: string) {
	// 	return firebase.storage().ref();
	// }
}



// WEBPACK FOOTER //
// /app/src/app/core/services/organizers.service.ts